/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateMember.defs.js'
export * as $defs from './updateMember.defs.js'
